<template>
    <div>
        <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                      <el-button-group>
                          <el-button type="primary" icon="el-icon-menu">菜单</el-button>
                      </el-button-group>
                  </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">背新词</el-dropdown-item>
                <el-dropdown-item :command="2">复习</el-dropdown-item>
                <el-dropdown-item :command="3">新概念</el-dropdown-item>
                <el-dropdown-item :command="4" disabled>Englishpor</el-dropdown-item>
                <el-dropdown-item :command="5" divided>词典</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    export default {
        name: "MenuTool",
        methods: {
            handleCommand(command) {

                switch(command)
                {
                    case 1:
                        this.$store.dispatch('requireNewWord');
                        this.$bus.$emit('newWordLoad');
                        this.$store.commit('setShowModuleList', '背词');
                        this.$store.commit('deleteShowModuleList', '查词');
                        this.$store.dispatch('requirePlanWord');
                        this.$store.dispatch('requireAllPlanWord');
                        break;
                    case 2:
                        this.$store.dispatch('requirePlanWord');
                        this.$store.dispatch('requireAllPlanWord');
                        this.$store.dispatch('requireReviewWord').then(res=>{
                            this.$message({
                                message: res,
                                type: 'error',
                                duration:3000
                            });
                            // alert(res)
                        });
                        // this.$bus.$emit('newWordLoad');
                        this.$store.commit('setShowModuleList', '背词');
                        this.$store.commit('deleteShowModuleList', '查词');
                        break;
                        // this.$message({
                    //     message: '复习模块还在完善中',
                    //     type: 'success',
                    //     duration:3000
                    // });
                    // break;
                    case 3:
                        this.$store.dispatch('requirePlanWord');
                        this.$store.dispatch('requireAllPlanWord');
                        // this.$message({
                        //     message: '新概念模块还在完善中',
                        //     type: 'success',
                        //     duration:3000
                        // });
                        break;
                    case 4:
                        this.$message({
                            message: 'englispor模块还在完善中',
                            type: 'success',
                            duration:3000
                        });
                        break;
                    case 5:
                        this.$store.commit('setShowModuleList', '查词');
                        this.$store.commit('deleteShowModuleList', '背词');
                        break;
                    default:

                }

            },
        }
    }
</script>

<style scoped>

</style>